import React from "react"
import Switch from "../Switch/Switch"

//import I18n from "i18n-js/index.js.erb"
import BillingPolicyBuilderConstants from "./constants/BillingPolicyBuilderConstants"
import CurrencyInput from "../CurrencyInput/CurrencyInput"
import PercentageInput from "../PercentageInput/PercentageInput"

class BillingPolicyDepositForm extends React.Component {

	constructor(props) {
    super(props);
		this.deposit_inputs = React.createRef();
    this.onChange = this.onChange.bind(this);
	};

  componentDidUpdate() {
  	// this.initSwitches();
  	// toggle deposit inputs?
    // if (this.refs['deposit-inputs']) {
    //   if (this.props.collect_reservation_deposit) {
    //     $(this.refs['deposit-inputs']).slideDown('normal');
    //   } else {
    //     $(this.refs['deposit-inputs']).slideUp('normal');
    //   };
    // };
		// if (this.deposit_inputs) {
		// 	if (this.props.collect_reservation_deposit) {
		// 		$(this.deposit_inputs).slideDown('normal');
		// 	} else {
		// 		$(this.deposit_inputs).slideUp('normal');
		// 	};
		// };
  };

  /*******************
  * Render functions *
  ********************/

	render() {
     return (
      <div>
        <h5 className="panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20}}>{I18n.t('deposit')}</h5>

        <div className="row">
          <div className="col-sm-12">
            <label>{I18n.t('would_you_like_to_collect_a_reservation_deposit')}</label>
            {/* <br style={{lineHeight: '30px'}} /> */}
            {
              this.props.read_only
              ?
              <div>{I18n.t(this.props.collect_reservation_deposit ? 'yes' : 'no')}</div>
              :
							<Switch
								onText="yes"
								offText="no"
								onChange={this.props.onChangeCollectReservationDeposit}
								value={this.props.collect_reservation_deposit}
								switchId="collect-reservation-deposit-switch"
							/>
              // <input type="checkbox" ref="collect_reservation_deposit" defaultChecked={this.props.collect_reservation_deposit} />
            }
            {/* <input type="hidden" name={this.inputName('collect_reservation_deposit')} value={this.props.collect_reservation_deposit} onChange={this.onChange.bind(this, 'collect_reservation_deposit')} /> */}
          </div>
        </div>
				{
					this.props.collect_reservation_deposit
						?
					<div>
						<br />
						<div className="row">

							<div className="col-lg-6">
								<div className="card" style={{paddingBottom: 19, marginBottom: 15}}>
									<h5 className="panel-heading-text">{I18n.t('when')}</h5>
									{this.renderLifecycleEventSection(this.props.deposit_lifecycle_event || 'reservation_created', 'deposit_lifecycle_event', true)}
									{this.renderTimePeriodSection(this.props.deposit_time_period, this.props.deposit_lifecycle_event || 'reservation_created', 'deposit_time_period', I18n.t('collect_deposit'))}
									{this.renderTimeValueSection(this.props.deposit_time_period, this.props.deposit_time_value, 'deposit_time_value')}
								</div>
							</div>

							<div className="col-lg-6">
								<div className="card" style={{paddingBottom: 19}}>
									<h5 className="panel-heading-text">{I18n.t('how_much')}</h5>

									<div className="row">
										<div className="col-sm-12">
											<div className="form-group" style={{marginBottom: 0}}>
												<label>{I18n.t('fixed_amount')} <span className="ss-help help" title={I18n.t('fixed_amount_helper_text')}></span></label>
												{this.props.read_only ? <div style={{marginBottom: 15}}>${this.props.deposit_amount / 100}</div> : <div className="input-group input-group-currency">
													{/* <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div> */}
													 <CurrencyInput name="deposit_amount" value={this.props.deposit_amount ? this.props.deposit_amount : ""} onChange={this.props.onChangeAmount} className={this.renderFieldClasses('deposit_amount')} />
												</div>}
												{this.renderFieldErrors('deposit_amount')}
											</div>
										</div>
									</div>

									{this.props.read_only ? null : <div className="row">
										<div className="col-sm-12 text-center" style={{marginTop: 15, marginBottom: 15}}>
											<em>{I18n.t('or')}</em>
										</div>
									</div>}

									<div className="row">
										<div className="col-sm-12">
											<div className="form-group" style={{marginBottom: 0}}>
												<label>{I18n.t('percentage_of_total')} <span className="ss-help help" title={I18n.t('percentage_of_total_helper_text')}></span></label>
												{this.props.read_only
												?
												<div style={{marginBottom: 15}}>{this.props.deposit_percentage * 100}%</div>
												:
												<div className="input-group input-group-numeric">
													 <PercentageInput name="percentage" value={this.props.deposit_percentage ? this.props.deposit_percentage : ""} onChange={this.props.onChangePercent} className={this.renderFieldClasses('deposit_percentage')} maxLength="5"  />
													<div className="input-group-addon"></div>
												</div>}
												{this.renderFieldErrors('deposit_percentage')}
											</div>
										</div>
									</div>

									{this.props.read_only ? null : <div className="row">
										<div className="col-sm-12 text-center" style={{marginTop: 15, marginBottom: 15}}>
											<em>{I18n.t('or')}</em>
										</div>
									</div>}

									<div className="row">
										<div className="col-sm-12">
											<div className="form-group" style={{marginBottom: 0}}>
												<label>{I18n.t('number_of_nights')} <span className="ss-help help" title={I18n.t('date_based_helper_text')}></span></label>
												{this.props.read_only ? <div>{this.props.deposit_days || 0}</div> : <div className="input-group input-group-numeric">
													 <input type="text" name='deposit_days' value={this.props.deposit_days ? this.props.deposit_days : ''} onChange={this.props.onChangeDepositDays} className={this.renderFieldClasses('deposit_days')} />
													<div className="input-group-addon"></div>
												</div>}
												{this.renderFieldErrors('deposit_days')}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>


					</div>
						:
					null
				}

        {/* <div className="deposit-inputs" ref={this.deposit_inputs} style={{display: this.props.read_only && this.props.collect_reservation_deposit ? 'block' : 'auto'}}>
        </div> */}
      </div>
    );
	};

  renderLifecycleEventSection(lifecycle_event, input_name, exclude_check_out_date) {
    if (exclude_check_out_date === true) {
      return (
        <div className="form-group">
          <label>{I18n.t('event')}</label>
          <br />
          {this.props.read_only ? <div>{I18n.t(lifecycle_event)}</div> : <select name={this.inputName(input_name)} value={lifecycle_event || ''} onChange={this.onChange.bind(this, input_name)} className="form-control">
            <option value="reservation_created">{I18n.t('reservation_created')}</option>
            <option value="check_in_date">{I18n.t('check_in')}</option>
          </select>}
        </div>
      );
    } else {
      return (
        <div className="form-group">
          <label>{I18n.t('event')}</label>
          <br />
          {this.props.read_only ? <div>{I18n.t(lifecycle_event)}</div> : <select name={this.inputName(input_name)} value={lifecycle_event || ''} onChange={this.onChange.bind(this, input_name)} className="form-control">
            <option value="reservation_created">{I18n.t('reservation_created')}</option>
            <option value="check_in_date">{I18n.t('check_in')}</option>
            <option value="check_out_date">{I18n.t('check_out')}</option>
          </select>}
        </div>
      );
    }
  }

  renderTimePeriodSection(time_period, lifecycle_event, input_name, label_text) {
    return (
      <div className="form-group" style={{marginBottom: 0}}>
        <label>{I18n.t('collect_amount')}</label>
        <br />
        {
            this.props.read_only 
          ? 
            <div>{I18n.t(time_period)}</div> 
          : 
            <select name={this.inputName('[' + input_name + ']')} value={time_period || ''} onChange={this.onChange.bind(null, input_name)} className="form-control">
              {
                  this.props.rules[lifecycle_event].indexOf(BillingPolicyBuilderConstants.IMMEDIATELY) == -1 
                ? 
                  null 
                : 
                  <option value={BillingPolicyBuilderConstants.IMMEDIATELY}>{I18n.t('immediately')}</option>
              }
              {
                lifecycle_event !== 'check_in_date'
                ? 
                  null
                : 
                  <option value={BillingPolicyBuilderConstants.BEFORE}>{I18n.t('before')}</option>
              }
              {
                lifecycle_event !== 'reservation_created' 
                ? 
                  null 
                : 
                  <option value={BillingPolicyBuilderConstants.AFTER}>{this.capitalize(I18n.t('after'))}</option>
              }
            </select>
        }
      </div>
    );
  };

  renderTimeValueSection(time_period, time_value, input_name) {
    if (time_period == 'After' || time_period == 'Before') {
      return (
        <div className="form-group" style={{marginTop: 15, marginBottom: 0}}>
          <div className="input-group">
            {this.props.read_only ? <div>{time_value} {I18n.t('days')}</div> : <input name={this.inputName('[' + input_name + ']')} value={time_value || ''} onChange={this.onChange.bind(null, input_name)} type="number" min="1" step="1" className="form-control days-input text-right" />}
            <div className="input-group-append">
            {this.props.read_only ? null : <span className="input-group-text">{I18n.t('days')}</span>}
            </div>
          </div>
        </div>
      );
    };
  };

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        if (error) {
          idx = idx + 1;
          return <li key={idx}><b>&#x2022;</b> {error}</li>;
        };
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    };
    return classname;
  };

  /******************
  * Change handlers *
  *******************/

  onChange(name, event) {
    var value = event.target.value;
    
    if (value ) {
      if (name == 'deposit_amount') {
        this.props['deposit_percentage'] = '';
        this.props['deposit_days'] = '';
      } else if (name == 'deposit_percentage') {
        this.props['deposit_amount'] = '';
        this.props['deposit_days'] = '';
      } else if (name == 'deposit_days') {
        this.props['deposit_percentage'] = '';
        this.props['deposit_amount'] = '';
      }
    }
    // this.props[name] = value;
    this.setState(this.props, () => {
      if (typeof this.props.onChange == 'function') {
        if (value) {
          if (name == 'deposit_amount') {
            this.props.onChange('deposit_percentage', {target: {value: ''}});
            this.props.onChange('deposit_days', {target: {value: ''}});
          } else if (name == 'deposit_percentage') {
            this.props.onChange('deposit_amount', {target: {value: ''}});
            this.props.onChange('deposit_days', {target: {value: ''}});
          } else if (name == 'deposit_days') {
            this.props.onChange('deposit_amount', {target: {value: ''}});
            this.props.onChange('deposit_percentage', {target: {value: ''}});
          }
        }

				this.props.onChange(name, {target: {value: value}});

      };
    });
  };

  /*******************
  * Helper functions *
  ********************/

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

	// initSwitches() {
  //   var self = this;
	//
  //   if (this.refs.collect_reservation_deposit) {
  //     var $collectDeposit = $(this.refs.collect_reservation_deposit);
	//
  //     if (typeof $collectDeposit.data('bootstrapSwitch') == 'undefined') {
  //       $collectDeposit.bootstrapSwitch({
  //         onText: I18n.t('yes'),
  //         offText: I18n.t('no'),
  //         size: 'small'
  //       }).on('switchChange.bootstrapSwitch', function (event, state) {
  //         self.onChange('collect_reservation_deposit', {target: {value: state}});
  //       });
  //     };
  //   };
  // };

  inputName(name, obj) {
    var inputName = 'billing_policy';

    inputName = inputName + name;

    return inputName;
  };

};

export default BillingPolicyDepositForm
